import cx from 'classnames';
import {isEmpty} from 'lodash';
import {useContext, useMemo} from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {ProfileMenu} from 'components';
import {APP_NAME} from 'constants/app';
import {ROUTE_PATH} from 'constants/routes';
import {UserContext} from 'context';
import {imageUtils} from 'utils';

import {SubMenuItemsDropdown} from '../SubMenuItemsDropdown';
import {MenuItemInfo} from '../types';

type Props = {
    menuItems: MenuItemInfo[];
    isAvailable: boolean;
    notificationsEnabled: boolean;
    dynamicHeader?: React.ReactNode
    onAvailabilityChange: (value: boolean) => void;
    onNotificationsEnabledChange: (value: boolean) => void;
};

export const MainHeader: React.FC<Props> = ({
    menuItems, isAvailable, notificationsEnabled, dynamicHeader, onAvailabilityChange, onNotificationsEnabledChange
}: Props) => {
    const {settings} = useContext(UserContext);
    const logoParams = useMemo(() => settings.common.logo ? {
        src: settings.common.logo,
        alt: 'Logo'
    } : {
        src: imageUtils.getLogo(),
        alt: APP_NAME
    }, [settings]);

    return (
        <header className='tw-w-full tw-fixed tw-z-header tw-h-20 tw-flex tw-items-center tw-p-6 tw-bg-layout'>
            <RouterLink to={ROUTE_PATH.USER.ONLINE._SELF} className='tw-hidden lg:tw-block'>
                <img src={logoParams.src} alt={logoParams.alt} className='tw-h-7' />
            </RouterLink>
            {!isEmpty(menuItems) && <SubMenuItemsDropdown menuItems={menuItems} />}
            {dynamicHeader &&
                <div className='tw-ml-auto tw-mr-4'>
                    {dynamicHeader}
                </div>}
            <div className={cx({'tw-ml-auto': !dynamicHeader})}>
                <ProfileMenu
                    isAvailable={isAvailable}
                    notificationsEnabled={notificationsEnabled}
                    onAvailabilityChange={onAvailabilityChange}
                    onNotificationsEnabledChange={onNotificationsEnabledChange}
                />
            </div>
        </header>
    );
};